import * as React from "react";
const clients = [{
  id: 1,
  name: "Partner Alpha",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/044.png?v=8u8bhulnr42",
  srcset: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/044.png?v=dye0dov480c-wvc-srcset",
  sizes: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/044.png?v=88oda4x1id3-wvc-sizes"
}, {
  id: 2,
  name: "Partner Beta",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/049.png?v=haauiinsxki",
  srcset: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/049.png?v=s2qaudijp8s-wvc-srcset",
  sizes: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/049.png?v=dx6ym73t1x7-wvc-sizes"
}, {
  id: 3,
  name: "Partner Gamma",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/048.png?v=utxg83fdmxr",
  srcset: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/048.png?v=brmcsp1l6ci-wvc-srcset",
  sizes: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/048.png?v=jffneb2y10s-wvc-sizes"
}, {
  id: 4,
  name: "Partner Delta",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/047.png?v=9j0c130rq04",
  srcset: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/047.png?v=pqp14a61ge-wvc-srcset",
  sizes: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/047.png?v=4fmb7l6iap-wvc-sizes"
}, {
  id: 5,
  name: "Partner Epsilon",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/046.png?v=69ce4a67t1",
  srcset: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/046.png?v=kkot0xcgpf-wvc-srcset",
  sizes: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/046.png?v=7dtncjf2sx4-wvc-sizes"
}, {
  id: 6,
  name: "Partner Zeta",
  logo: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/043.png?v=xhggicibl6",
  srcset: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/045.png?v=6h7w0nl1isw-wvc-srcset",
  sizes: "https://exotic-skylark.10web.cloud/wp-content/uploads/2026/05/045.png?v=7ipfbqlmg6g-wvc-sizes"
}];
const marqueeClients = [...clients, ...clients];
export default function ClientCarouselFooter() {
  return <section id="client-carousel-footer" className="w-full bg-muted py-16 overflow-hidden light">
      <div className="container mx-auto px-4 md:px-12">
        <h2 className="text-2xl md:text-3xl font-default font-bold text-center text-foreground mb-10">
          Our Trusted Partners
        </h2>
        
        <div className="relative w-full">
          {}
          <div className="flex w-full overflow-hidden select-none">
            <div className="flex min-w-full shrink-0 items-center justify-around gap-8 animate-[marquee_30s_linear_infinite]" style={{
            animation: 'marquee 30s linear infinite'
          }}>
              {marqueeClients.map((client, i) => <div key={`${client.id}-${i}`} data-index={i} className="flex-none w-40 md:w-48 lg:w-56">
                  <div className="flex items-center justify-center p-6 h-28 bg-background rounded-lg shadow-sm border border-border/50 transition-all hover:shadow-md hover:border-border">
                    <img src={client.logo} data-wvc-srcset={client.srcset} data-wvc-sizes={client.sizes} alt={`${client.name} logo`} className="max-h-full max-w-full object-contain opacity-70 hover:opacity-100 transition-opacity duration-300 grayscale hover:grayscale-0" loading="lazy" />
                  </div>
                </div>)}
            </div>
            
            {}
            <div className="flex min-w-full shrink-0 items-center justify-around gap-8 animate-[marquee_30s_linear_infinite]" aria-hidden="true" style={{
            animation: 'marquee 30s linear infinite'
          }}>
              {marqueeClients.map((client, i) => <div key={`dup-${client.id}-${i}`} className="flex-none w-40 md:w-48 lg:w-56">
                  <div className="flex items-center justify-center p-6 h-28 bg-background rounded-lg shadow-sm border border-border/50 transition-all hover:shadow-md hover:border-border">
                    <img src={client.logo} data-wvc-srcset={client.srcset} data-wvc-sizes={client.sizes} alt={`${client.name} logo`} className="max-h-full max-w-full object-contain opacity-70 hover:opacity-100 transition-opacity duration-300 grayscale hover:grayscale-0" loading="lazy" />
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
      `
    }} />
    </section>;
}